module.exports = __webpack_public_path__ + "img/financialservice_01.2ddbd424.png";